import { Box, List, Stack, Typography, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const LogsContainer = muiStyled(Stack)(() => ({
  height: '100%',
  width: '100%',
}));

export const LogsList = muiStyled(List)(() => ({
  width: '100%',
  flex: '1 1 auto',
  overflowY: 'auto',
  position: 'relative',
  padding: '16px',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: abyssColors.primary[300],
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: abyssColors.primary[400],
  },
}));

export const LogEntry = muiStyled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isFirst' && prop !== 'isLast',
})<{ isFirst?: boolean; isLast?: boolean }>(({ isFirst, isLast }) => ({
  position: 'relative',
  minHeight: 50,
  paddingLeft: 25,
  paddingBottom: 20,
  display: 'flex',
  flexDirection: 'row',

  '&::before': {
    content: '""',
    position: 'absolute',
    left: 5,
    top: 16,
    width: 12,
    height: 12,
    borderRadius: '50%',
    border: `2px solid ${isFirst ? abyssColors.primary[300] : abyssColors.neutral[400]}`,
    backgroundColor: isFirst ? abyssColors.primary[300] : abyssColors.primary[50],
    zIndex: 2,
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    left: 10,
    top: isFirst ? 22 : 0,
    bottom: isLast ? 'auto' : 0,
    height: isFirst && isLast ? '0' : isLast ? '16px' : 'auto',
    width: isFirst && isLast ? '0' : '2px',
    backgroundColor: isFirst && isLast ? 'transparent' : abyssColors.neutral[400],
    zIndex: 1,
  },
}));

export const LogContent = muiStyled(Box)(() => ({
  flex: 1,
  marginTop: 10,
  paddingLeft: 10,
}));

export const LogHeader = muiStyled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  gap: '4px',
}));

const BaseTypography = muiStyled(Typography)({}) as typeof Typography;

export const UserName = muiStyled(BaseTypography)(() => ({
  fontSize: '12px',
  fontWeight: 500,
  color: abyssColors.primary[900],
}));

export const LogAction = muiStyled(BaseTypography)(() => ({
  fontSize: '12px',
  color: abyssColors.primary[500],
  fontWeight: 400,
}));

export const Timestamp = muiStyled(BaseTypography)(() => ({
  fontSize: '12px',
  color: abyssColors.primary[500],
  marginTop: 4,
}));

export const LogDetails = muiStyled(Box)(() => ({
  color: abyssColors.primary[500],
  fontSize: '12px',
  marginTop: 8,
  marginLeft: -45,
  display: 'flex',
  flexDirection: 'row',
}));
export const Value = muiStyled(BaseTypography)<{ isComment?: boolean }>(({ isComment }) => ({
  color: isComment ? abyssColors.primary[400] : abyssColors.primary[500],
  fontSize: '12px',
  fontWeight: isComment ? 400 : 500,
  marginLeft: 4,
}));
